<template>
<section
	class="navigation"
	:class="{ 'navigation--active' : active }"
>
	<ul>
		<li
			v-for="(navItem, key) in navItems"
			:key="`menuItem${key}`"
			class="navigation__item"
		>
			<span @click="goToLink(navItem.path)">
				{{ navItem.name }}
			</span>
		</li>
	</ul>
</section>
</template>

<script>
export default {
	name: 'Navigation',
	props: {
		active: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		navItems() {
			return this.$router.options.routes.filter((route) => {
				return route.meta.includeInMenu
			}).map((item) => {
				return {
					name: item.name,
					path: item.path
				}
			})
		}
	},
	methods: {
		goToLink(path) {
			this.$router.push(path)
			this.$emit('toggle')
			window.scrollTo(0, 0)
		}
	}
}
</script>

<style lang="scss" scoped>
.navigation {
	position: relative;
	visibility: hidden;
	opacity: 0;
	transition: opacity 400ms ease-in-out;
	height: 0px;

	&--active {
		visibility: visible;
		opacity: 1;
		transition-delay: 100ms;
		position: absolute;
		height: auto;
		width: calc(100% - #{$site-padding-lrg * 2});
		top: 50%;
		transform: translateY(-50%);
		z-index: 100;
	}

	ul {
		display: flex;
		align-items: baseline;
		justify-content: space-evenly;

		.navigation__item {
			font-family: $maison;
			text-transform: uppercase;

			span {
				font-size: $heading;
				cursor: pointer;
				transition: color 200ms ease-in-out;

				&:hover {
					color: lightgrey;
				}
			}
		}
	}

	@include mobile {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		left: 0px;
		width: 100%;
		padding: $site-padding--m $mobile-padding;

		ul {
			flex-direction: column;
			width: 100%;

			.navigation__item {
				margin: #{$site-padding--m * 1.5} 0;
				width: 100%;
				text-align: center;

				span {
					font-size: $heading-lrg--m;
				}
			}
		}
	}
}
</style>
